'use client';

import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { useState, useCallback, createElement } from "react";
import { ToastNotification } from "../../molecules/ToastNotification/ToastNotification.js";
import { ChalkPortal } from "../../quarks/ChalkPortal/ChalkPortal.js";
import { toastManager } from "./utils/ToastManager.js";
import { useSmoothRepositioning } from "./utils/useSmoothRepositioning.js";
import { useToastManagerInit } from "./utils/useToastManagerInit.js";
import { useToastManagerUpdate } from "./utils/useToastManagerUpdate.js";
import { toastNotificationsContainer } from "./ChalkToastProvider.css.js";
function ChalkToastProvider({ children }) {
  const [toastNotifications, setToastNotifications] = useState([]);
  const recordPositionsRef = useSmoothRepositioning(toastNotifications);
  useToastManagerInit(toastManager, setToastNotifications, () => {
    recordPositionsRef.current();
  });
  useToastManagerUpdate(toastManager, toastNotifications, () => {
    recordPositionsRef.current();
  });
  const pauseAll = useCallback(() => toastManager.pause(), []);
  const resumeAll = useCallback(() => toastManager.resume(), []);
  if (!toastManager.portalDomNode || toastNotifications.length === 0) {
    return children;
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    children,
    /* @__PURE__ */ jsx(ChalkPortal, { element: toastManager.portalDomNode, children: /* @__PURE__ */ jsx(
      "div",
      {
        className: toastNotificationsContainer,
        onBlur: resumeAll,
        onFocus: pauseAll,
        onMouseEnter: pauseAll,
        onMouseLeave: resumeAll,
        children: toastNotifications.map((toastNotificationProps) => /* @__PURE__ */ createElement(
          ToastNotification,
          {
            ...toastNotificationProps,
            key: toastNotificationProps.id
          }
        ))
      }
    ) })
  ] });
}
export {
  ChalkToastProvider
};
